import { Content } from '../content/content.model';
import { ErrorMessage } from '../error/error-message.model';

// RUBRICHE
export const CANALI_LOGGATI_ID_RUBRICA = 59;
export const CANALI_NON_LOGGATI_ID_RUBRICA = 62;
export const ARTICLE_TPL_DESCRIPTION = 'articolo';
export const VIDEO_TPL_DESCRIPTION = 'video';
export const MEDLEX_ID_CATEGORIE = '58';
export const BULLETIN_ID_CATEGORIE = '66';
export const AIFA_ID_CATEGORIE = '65';
export const GUIDELINE_ID_CATEGORIE = '82';
export const INSTITUTIONS_ID_CATEGORIE = '59,60,62';
export const INTERESTING_ID_CATEGORIE = '44';
export const INSIGHTS_ID_RUBRICA = 22;
export const FOCUS_VIDEO_ID_RUBRICA = 23;
export const FOCUS_MEDICINA_ID_RUBRICA = 53;
export const HOME_HEADER_BANNER_ID_RUBRICA = 61;
export const HOME_NOT_BE_MISSED_ID_RUBRICA = 60;
export const HOME_HIGHLIGHT_ID_RUBRICA = 52;
export const HOME_VIDEO_ID_RUBRICA = 54;
export const HOME_EXTRA_ID_RUBRICA = 58;
export const HOME_CONTENT_SECTION2_TOPIC_ID = 57;

export interface DNContentState {
  content: Content[];
  error: ErrorMessage;
}

export interface DNFocusContentState {
  mainContent: Content;
  listContent: Content[];
  error: ErrorMessage;
}

export interface WidgetState {
  medlexContent: DNContentState;
  bulletinContent: DNContentState;
  aifaContent: DNContentState;
  institutionsContent: DNContentState;
  highlightedContent: DNContentState;
  mostReadContent: DNContentState;
  latestNewsContent: DNContentState;
  latestVideosContent: DNContentState;
  focusArticleContent: DNFocusContentState;
  focusVideoContent: DNFocusContentState;
  insightsContent: DNContentState;
  relatedContent: DNContentState;
  interestingContent: DNContentState;
  guidelineContent: DNContentState;
  notBeMissedContent: DNContentState;
  extraContent: DNContentState;
  homeHeroContent: DNContentState;
  homeVideoContent: DNContentState;
  contentHomeSection1Content: DNContentState;
  contentHomeSection2Content: DNContentState;
  homeHeaderBannerContent: DNContentState;
  relatedTopicContent: DNContentState;
  // Slice propria: la pagina minisiti/canali non deve condividere relatedTopicContent con l'articolo.
  relatedBySpecializzazioneContent: DNContentState;
  lastContentsByTemplateContent: DNContentState;
  // "Altro che potrebbe interessarti" (dynamic-home): ultimi minisiti/canali per data_creazione.
  latestContainersContent: DNContentState;
}
